var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49982 2H9.50482H9.49982ZM9.49982 2L6.99982 8L11.9998 10.898L4.49982 18L6.99982 12L1.99982 9.1L9.49982 2ZM9.49982 9.18826e-07C8.98687 0.00191444 8.49386 0.198905 8.12082 0.551001L0.623825 7.646C0.397962 7.86018 0.225207 8.12412 0.119309 8.41682C0.0134098 8.70951 -0.0227096 9.02289 0.0138245 9.332C0.0858245 9.958 0.450824 10.514 0.995824 10.83L4.47782 12.851L2.65182 17.232C2.52578 17.5361 2.47662 17.8665 2.50868 18.1941C2.54074 18.5217 2.65304 18.8363 2.83565 19.1102C3.01826 19.3841 3.26554 19.6087 3.55563 19.7642C3.84572 19.9198 4.16967 20.0015 4.49882 20.002C4.99682 20.002 5.49182 19.816 5.87382 19.454L13.3738 12.351C13.5995 12.1369 13.7722 11.8732 13.8781 11.5806C13.984 11.2881 14.0202 10.975 13.9838 10.666C13.9478 10.3572 13.8404 10.061 13.6699 9.80092C13.4994 9.54089 13.2707 9.32418 13.0018 9.168L9.51982 7.15L11.3088 2.857C11.4535 2.55201 11.5186 2.21537 11.498 1.87845C11.4775 1.54152 11.3721 1.21527 11.1915 0.930079C11.0109 0.64489 10.7611 0.410045 10.4653 0.247419C10.1695 0.0847931 9.83737 -0.000322602 9.49982 9.18826e-07Z",
    fill: "url(#paint0_linear_448_41410)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_41410",
    x1: 0,
    y1: 10.001,
    x2: 13.9975,
    y2: 10.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.be084890431602a969605e3b5859114a.svg";
export { ForwardRef as ReactComponent };